import { useContext } from 'react';
import { RootStoreContext } from '../store/RootStore';

export const useStore = () => {
  const store = useContext(RootStoreContext);
  if (!store) {
    throw new Error('Store is missing. Wrap your app with RootStoreProvider');
  }
  return store;
};
